import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import imgRecommendations from "../../../assets/recommendations-cover-2.png";
import { useHistory } from "react-router-dom";

/* import imgGirl from "../../../assets/cover-girl.png"; */



function LandingCover() {

  const history = useHistory();

  function handleClick() {
    history.push('/signup/?user=1');
  }

  return (
    <div>
    <div className="cover">
        <div className="cover-texts">
            <Typography
            variant="h3"
            component="h1"
            className="landing-title"
            id="cover-texts-h"
            >
            Descubrí la información que está en tus genes.
            </Typography>
            <Typography
            variant="body1"
            component="p"
            className="landing-p"
            id="cover-texts-p"
            >
            Te ayudamos a que alcances tu peso saludable, objetivos deportivos y bienestar comenzando con una prueba.
            <br/><br/>
            🔬 Tu ADN tiene las respuestas. Nosotros te ayudamos a interpretarlas.
            </Typography>
            <div className="cover-texts-button">
                <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={handleClick}
                >
                    Comprar Kit
                </Button>
                <Button
                    variant="outlined"
                    disableElevation
                    endIcon={<ArrowForwardIcon />}
                    href="#que-es-Mr-Gen"
                >
                    Quiero saber más
                </Button>
            </div>
        </div>
        <div className="cover-recomendations-girl">
            <div className="cover-rec">
              <img src={imgRecommendations} height="100%" alt="recomendaciones personalizadas"/>
            </div>
            <div className="cover-girl">
              <div className="indicators">
                <div className="items">
                  <div className="itemsrel">
                    <div className="item1"><strong>Grasas</strong> <span>5%</span></div>
                    <div className="item2"><strong>Proteínas</strong> <span>20%</span></div>
                    <div className="item3"><strong>Carbohidratos</strong> <span>10%</span></div>
                  </div>
                  
                </div>
                
              </div>
              <img src="https://res.cloudinary.com/hqs-cdn/image/upload/v1634906803/mistergen/cover-girl_hpypuy.png" height="100%" alt="análisis nutrigenéticos" />
              
            </div>   
        </div>
    </div>
</div>
    
  );
}

export default LandingCover;